import React from "react";

import InvestorPageMUICentered from "./investors";
import MissionVisionSection from "./Mission";


function About() {
  return (
 <>
      <MissionVisionSection/>

       <InvestorPageMUICentered />
 </>

  );
}

export default About;
